<template>
  <div>
    <h1 class="display-4">Liste des écoles</h1>
    <hr />

    <router-link tag="p" to="/school/edit">
      <a class="btn btn-large btn-primary">Ajouter une école</a>
    </router-link>

    <b-table class="mt-3" :dark="theme == 'dark'" responsive hover striped :items="schools" :fields="fields" :current-page="currentPage" :per-page="perPage" v-show="totalRows > 0">
      <template slot="actions" slot-scope="cell">
        <router-link tag="a" class="btn btn-sm btn-primary" :to="{ name: 'SchoolEditExist', params: {id: cell.item.id } }">
          Editer
        </router-link>
      </template>
    </b-table>

    <b-row v-show="totalRows > perPage">
      <b-col md="6" class="my-1">
        <b-pagination :total-rows="totalRows" :per-page="perPage" v-model="currentPage" class="my-0" />
      </b-col>
    </b-row>

    <p class="text-center" v-show="totalRows == 0"><em>Il y a aucune école pour le moment...</em></p>
  </div>
</template>

<script>
import Vue from 'vue'
import VueResource from 'vue-resource'
import Vuex from 'vuex'

Vue.use(VueResource)

export default {
  data () {
    return {
      currentPage: 1,
      fields: {
        id: {
          label: '#',
          sortable: false
        },
        name: {
          label: 'Nom',
          sortable: false
        },
        actions: {
          label: 'Actions',
          key: 'actions'
        }
      },
      schools: [],
      perPage: 20
    }
  },
  computed: {
    ...Vuex.mapGetters(['access_token', 'domain', 'theme']),
    totalRows () {
      return this.schools.length
    }
  },
  mounted () {
    this.$http.get(this.domain + '/api/schools?access_token=' + this.access_token + '&filter[order]=name ASC').then((response) => {
      response.json().then((data) => {
        this.schools = data
      })
    }, (response) => {

    })
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Schools/List.vue